import React, { useCallback, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import EarningDetails from "../../../Components/Earning/EarningDetails";
import Layout from "../../../Components/Layout";
import useHttpHook from "../../../Hooks/HttpHook";
import {
  OrganizerEarningDetails,
  OrganizerEarningDetailsCommission,
} from "../../../utils/ApiConstant";
import { createObjectForPaginatedResult } from "../../../utils/Helper";
import { toast } from "react-toastify";
import EarningDetailsCommission from "../../../Components/Earning/EarningDetailsCommission";
import { showErrorToast } from "../../../utils/notify";

const EarningDetailsPageCommission = () => {
  const { eventId } = useParams();
  const [details, setDetails] = useState({});
  const [timeSpanInput, setTimeSpanInput] = useState("");
  const [loading, sendRequest, error] = useHttpHook();
  const query = new URLSearchParams(window.location.search);

  const redirectUrl = query.get("redirectUrl");

  useEffect(() => {
    getDetails();
  }, [timeSpanInput]);

  useEffect(() => {
    if (error) {
      if (toast.isActive(error) === false) {
        showErrorToast(error);
        if (error === "You are unAuthrised") {
          window.location.href = `${process.env.REACT_APP_MERCH_URL}/login`;
        }
      }
    }
  }, [error]);
  const getDetails = async () => {
    try {
      const res = await sendRequest(
        timeSpanInput
          ? `${OrganizerEarningDetailsCommission}/${eventId}?timeSpan=${timeSpanInput}`
          : `${OrganizerEarningDetailsCommission}/${eventId}`,
        {
          method: "get",
        }
      );

      if (res.status === 1) {
        setDetails(res.data);
      }
    } catch (error) {
      console.log({ error });
    }
  };

  const handleTimeSpan = (timeSpan) => {
    setTimeSpanInput(timeSpan);
  };

  return (
    <Layout Heading="Earning Details" TitleMark={true} TitleMarkClassName="event-earning-detail-title-mark" TitleClassName="event-earning-detail-title" HeadClassName="event-earning-detail-head" DetailsHead BackAction={redirectUrl} ExtraclassName="event-earning-detail-panel" activeMenuId="my-promotion-earnings">
      <EarningDetailsCommission
        isError={error}
        isLoading={loading}
        details={details}
        setDetails={setDetails}
        getDetails={getDetails}
        handleTimeSpan={handleTimeSpan}
        timeSpanInput={timeSpanInput}
        setTimeSpanInput={setTimeSpanInput}
      />
    </Layout>
  );
};

export default EarningDetailsPageCommission;
